###
Gridspy Data and Sensor code

Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###

### ===================== SENSOR DATA MODEL ================ ###

if not window.gs?
  window.gs = {}

if not window.dynamic_hostname?
  window.dynamic_hostname = "/d/"

to_utc = (local_date)->
  new Date(local_date.getUTCFullYear(), local_date.getUTCMonth(), local_date.getUTCDate(),  local_date.getUTCHours(), local_date.getUTCMinutes(), local_date.getUTCSeconds());

to_local = (utc_date)->
  new Date(utc_date).add(-new Date().getTimezoneOffset()).minutes();

find_nearest_value = (data_blocks, timestamp) ->
  # Searches data_blocks for the data nearest to timestamp. used for data hover.
  timestamp = gs.to_utc(timestamp)

  latest = null

  for block in data_blocks
    # Take offset into data based on start and end dates.
    idx = Math.round((timestamp - block.start_time) / (1000 * block.freq))

    if idx < 0
      idx = 0

    if 0 <= idx < block.data.length
      for inner in [idx..block.data.length - 1]
        if block.data[inner]?
          return block.data[inner]
    else
      latest = block.data[block.data.length - 1]

  if latest?
    return latest

  # Okay, so let's look in the last data block for a value
  block = data_blocks[data_blocks.length - 1]
  for inner in [block.data.length - 1..0] by -1
    if block.data[inner]?
      return block.data[inner]

  return null

calculate_statistics = (data_blocks, start, end, rounding=2, cost_kwh=0.12) ->
  if not data_blocks? or data_blocks.length == 0
    return {min: null, max: null, mean: null, totals: null, kwh: null, price:null};

  timespan_secs = (end - start) / 1000.0

  min = max = null
  total = 0
  samples = 0
  start = gs.to_utc(start)
  end = gs.to_utc(end)

  accum = 0      # A sum of all the samples
  integrated = 0 # Integrate the samples, assuming a linear transition from one to the next.

  last_sample = null
  missing_samples = 0

  timestamp_last_block_sample = null

  #for row in [start..end]
  for block in data_blocks
    # Take offset into data based on start and end dates.
    first_idx = Math.round((start - block.start_time) / (1000 * block.freq), 0)
    last_idx = Math.round((end - block.start_time) / (1000 * block.freq), 0)

    # completely skip this block.
    continue if last_idx < 0 or first_idx > block.data.length
    if timestamp_last_block_sample?
      last_block_end_idx = Math.round((timestamp_last_block_sample - block.start_time) / (1000 * block.freq), 0)
      # Ideal value here is -1, which means the previous block ended directly before this block started.
      if last_block_end_idx >= first_idx
        # Avoid overlap and double-counting between indexes.
        first_idx = last_block_end_idx + 1
      else if last_block_end_idx < -1
        missing_samples += -1 - last_block_end_idx
    if first_idx < 0
      first_idx = 0
    if last_idx >= block.data.length
      last_idx = block.data.length - 1

    block_integrated = 0
    timestamp_last_block_sample = block.start_time + (1000 * block.freq) * last_idx

    for idx in [first_idx..last_idx - 1]
      val = block.data[idx]

      unless val? and not isNaN(val)
        missing_samples += 1
        continue

      block_integrated += val
      if last_sample?
        block_integrated += ((last_sample + val) / 2) * (missing_samples)

      missing_samples = 0
      last_sample = val

      accum += val * block.freq / 60.0

      if min == null
        min = max = val

      if min > val || isNaN(min)
        min = val
      if max < val || isNaN(max)
        max = val

      total += val
      samples += 1

    integrated += block_integrated * (block.freq / 60.0)

  if min == null
    min = max = 0

  if samples > 0
    mean = total / samples
  else
    mean = 0

  kwh = integrated / 60 / 1000.0

  return {
    min: min.toFixed(rounding),
    max: max.toFixed(rounding),
    mean: mean.toFixed(rounding),
    total: total.toFixed(rounding),
    kwh: kwh.toFixed(1),
    accum: accum.toFixed(1)
    price: (cost_kwh * kwh).toFixed(2)}

flatten_data = (data_blocks, start, end) ->
  # Translates data from block based without dates to the interleaved format required by graphing libraries
  #  such as flotr
  start = gs.to_utc(start)
  end = gs.to_utc(end)

  ret = []

  #for row in [start..end]
  for block in data_blocks
    # Take offset into data based on start and end dates.
    first_idx = Math.round((start - block.start_time) / (1000 * block.freq), 0) - 1
    last_idx = Math.round((end - block.start_time) / (1000 * block.freq), 0) + 1

    # completely skip this block.
    continue if last_idx < 0 or first_idx > block.data.length

    if first_idx < 0
      first_idx == 0
    if last_idx >= block.data.length
      last_idx = block.data.length

    local_block_start = +to_local(block.start_time)

    for idx in [first_idx..last_idx]
      val = block.data[idx]
      continue unless val?
      ret.push [local_block_start + (1000 * block.freq * parseInt(idx)), val]

  return ret


class DataStore
  constructor: (loading, @freq, @start_time) ->
    @data = []
    @loading = loading
    @last_update = new Date()

  end_time: () ->  new Date(@start_time).add(@data.length * @freq).seconds()

  load_queued: () ->
    @loading = true

  load_begin: () ->
    @loading = true

  load_done: (data) ->
    if data?
      @data = data

    @last_update = new Date()
    @loading = false

class DataCursor
  constructor: (@node, @unit='watts') ->
    # Compute and store the instruction set, eg ['+', ['+', 1, 3, 5], 7, 9]
    @ops = gs.maths_ops(@node, @unit, {no_conv:true})
    @pass_thru = not $.isArray(@ops)
    #@data = {} TODO: Cache calculated data in the cursor

    # Get a kernel function that applies the instructions and the list of PKs that are the args for the kernel.
    [@kernel, @args] = gs.build_array_func(@ops)

    #Some way to store calculated data
    # Needs to manage the freq of the calculated data. Perhaps substitute in data of a lower
    # resolution when possible

    # How do we track that new data is available?
    # Some sort of caching here: {'freq':1, 'start': new Date(2013, 5, 1)}

  get_data: (start_date, end_date, freq) ->
    final_data = []

    start_date = gs.to_utc(start_date)
    end_date = gs.to_utc(end_date)

    if freq >= 60 * 15
      day_list = make_day_list(start_date, end_date, 7)
    else
      day_list = make_day_list(start_date, end_date, 1)

    result = []
    complete = true
    for day in day_list
      [raw_data, day_complete] = gs.bindings.data_mgr.get_day_data(day, freq, @args)
      unless day_complete
        complete = false

      if @pass_thru
        # Copy the reference to the respective store directly to the output array.
        result.push(raw_data[0])
      else
        # Calculate and store intermediate values, creating a new DataStore to hold them.
        # TODO: Caching here.
        stores = for store in raw_data
          [store.data]

        new_store = new DataStore(not day_complete, freq, day)
        # Assume that the dates are consistent across all the stores
        new_store.start_time = raw_data[0].start_time

        data = window.gs.apply_func @kernel, stores
        new_store.load_done(data)
        result.push(new_store)

    return [result, complete]

fix_holes = (data)->
  # Removes holes in time, sample data by finding null / undefined values and replacing them with linear interpolation
  last_gd_idx = -1

  for own idx, sample of data
    # On the last time through the loop correct every value incl the last.
    #  Every other time keep looping looking for a sample if one is missing.
    unless (sample?) or (parseInt(idx) == data.length - 1)
      continue

    idx = parseInt(idx)
    if (last_gd_idx != idx - 1) or (not sample?)
      # Correct data between last_gd_idx and idx
      last_idx = idx
      if last_gd_idx == -1
        # Very first sample was bad
        prev_sample = sample
      else
        prev_sample = data[last_gd_idx]
        if not sample?
          sample = prev_sample
          last_idx += 1

      fixed_samples = last_idx - last_gd_idx
      interp_idx = last_gd_idx + 1
      while interp_idx < last_idx
        pos = ((interp_idx - last_gd_idx) / fixed_samples) # Between 0 and 1
        interp = prev_sample * (1 - pos ) + sample * pos
        data[interp_idx] = interp
        interp_idx += 1

    last_gd_idx = idx

  return data

missing_data_0 = (data)->
  # Removes holes in time, sample data by setting them to 0

  for own idx, sample of data
    idx = parseInt(idx)
    unless sample?
      data[idx] = 0

  return data

sum_data = (data, sensors)->
  accum = []

  sensor_idx = 0
  test = 1

  while data.length > sensor_idx
    to_add = data[sensor_idx]
    sensor = sensors[sensor_idx]
    combination = sensor.combination()
    #if to_add.length == 0
    #  complete = false

    acc_idx = 0
    if accum.length > 0
      for own idx, [date, sample] of to_add
        while acc_idx < accum.length and date - accum[acc_idx][0] > 500
          acc_idx += 1 # data missing from data...

        if combination == 'sub'
          sample = -sample

        if acc_idx >= accum.length
          for own idx, [date, sample] of to_add[idx..]
            accum.push([date, sample])
          break

        if Math.abs(date - accum[acc_idx][0]) < 500
          accum[acc_idx][1] += sample
          acc_idx += 1
        else if date < accum[acc_idx][0]
          # Insert this reading into accum
          accum.splice(acc_idx, 0, [date, sample])
    else
      # Deep copy of data[0] (going to modify the data)
      if combination == 'sum'
        for own idx, [date, sample] of to_add
          accum.push([date, sample])
      else if combination == 'sub'
        for own idx, [date, sample] of to_add
          accum.push([date, -sample])

    sensor_idx += 1

  return accum

# For managing the data downloaded by this client. Handles background loading while the customer navigates the data streams.
make_day_list = (start_date, end_date, day_span) ->
  temp_day = new Date(start_date).clearTime()
  if day_span == 7
    temp_day.last().monday()

  while temp_day <= end_date
    d = new Date(temp_day)
    temp_day.add(days: day_span)
    d

class SensorDataManager
  constructor: (@building) ->
    # Data stores:
    # Days
    # L__ Sensors (by PK)
    #     L__ Resolutions (in seconds
    #         L__ Instances of DataStore

    @data = {}
    @outstanding_reads = {}
    @outstanding_cb = undefined

    @second_buffer = {}
    @curr_requests = []

    @local_store = undefined

    @last_live_update = ko.observable new Date()

    @building = null

  server_request: (date, end_date, freq, sensor_pks, done_func)->
    if end_date
      url = "#{dynamic_hostname}#{@building}/history/#{date.toString('ddMMMyyyy')}-#{end_date.toString('ddMMMyyyy')}at#{freq/60}.json"
    else
      url = "#{dynamic_hostname}#{@building}/history/#{date.toString('ddMMMyyyy')}at#{freq/60}.json"

    $.ajax
      url: url
      dataType: 'json'
      success: (data, textStatus, jqXHR) =>
        #console?.log "Good response from server for #{date.getDate()}#{months[date.getMonth()]}#{date.getFullYear()} at #{freq}:", textStatus, data

        done_func true, data, textStatus
      error: (jqXHR, textStatus, errorThrown) =>
        #console?.log "Error from server for #{date.getDate()}#{months[date.getMonth()]}#{date.getFullYear()} at #{freq}:", textStatus, errorThrown

        done_func false, undefined, textStatus

  do_requests:() ->
    @outstanding_cb = undefined
    for own day_key, spans_missing of @outstanding_reads
      for own freq, sensors_missing of spans_missing
        for pk in sensors_missing
          @data[day_key][pk][freq].load_begin()

        gs.loading_mgr.load_data()

        day = new Date(parseInt(day_key))
        end_date = null
        if freq >= 15 * 60
          end_date = new Date(day).add(days: 7)

        curr_building = @building

        do (day,freq) => @server_request day, end_date, freq, sensors_missing, (success, data, textStatus) =>
          #    Note: This will trigger observables and therefore re-render dependant graphs
          if success

            if data['start']?
              # Server can provide a start time in the case of missing data / recently installed sites.
              data_start = Date.parseExact(data['start'], "yyyy-MM-ddTHH:mm:ssZ")
            else
              data_start = day

            for own pk, data_for_sensor of data
              continue if not data_for_sensor['means']?

              sensor_series = data_for_sensor['means']

              building = gs.bindings.building_list.by_tag(curr_building)
              if (not building?.consts?()['interp_results']?) or building.consts()['interp_results']
                fix_holes sensor_series
              else
                missing_data_0 sensor_series

              store = @get_store(day, pk, freq)
              store.load_done(sensor_series)
              store.start_time = data_start

              if @local_store?
                session_key = "#{day.toString('dMMMyyyy')}-#{pk}-#{freq}"
                @local_store.set(session_key, [sensor_series, new Date()])
                #console?.log "Stored #{session_key} into cache"

            for pk in sensors_missing
              if not pk in data
                console?.log "Sensor", pk, "was not found in recieved data!", data
                store = @get_store(day, pk, freq)
                store.load_done(undefined)
          else
            for pk in sensors_missing
              # Load failed, so flag the load as done in the sensor..
              store = @get_store(day, pk, freq)
              store.load_done(undefined)

          gs.loading_mgr.load_done()

    @outstanding_reads = {}
    gs.loading_mgr.update_loading()

  get_store:(day, pk, freq, sensors_missing=undefined, interpolate=true) ->
    day_key = +day

    if not @data[day_key]?
      @data[day_key] = {}

    day_data = @data[day_key][pk]

    if not day_data?
      day_data = @data[day_key][pk] = {}
    else
      poss_match = day_data?[freq]
      if poss_match?
        # TODO : Push sensor PK into sensors_missing if the data is stale.
        return poss_match

    day_data[freq] = store = new DataStore(true, freq, day)
    sensors_missing?.push pk

    return store

  begin_request:(day, freq, sensor_pks) ->
    day_key = +day

    if freq < 60 or freq % 60 != 0
      # Cannot load 1 second data from this routine
      #console?.log "Cannot load 1 second data from begin_request", day_key, freq, sensor_pks
      return

    # If some sensors need loading, initiate a download of fresh data from the server.
    if @outstanding_reads[day_key]?[freq]?
      reads = @outstanding_reads[day_key][freq]
      # Add pks and eliminate duplicates.
      for pk in sensor_pks
        if pk not in reads
          reads.push(pk)
          @data[day_key][pk][freq].load_queued()
    else
      if not @outstanding_reads[day_key]?
        @outstanding_reads[day_key] = {}

      # copy array.
      @outstanding_reads[day_key][freq] = sensor_pks[..]
      for pk in sensor_pks
        @data[day_key][pk][freq].load_queued()

    if not @outstanding_cb?
      @outstanding_cb = window.setTimeout (=> @do_requests()), 10


  get_day_data: (day, freq, pks) ->
    # Note : day is assumed to be in UTC time.
    complete = true
    sensor_data = []
    sensors_missing = []

    sensor_idx = -1
    for pk in pks
      sensor_idx += 1
      store = @get_store(day, pk, freq, sensors_missing)
      if store.loading
        complete = false

      sensor_data[sensor_idx] = store

    if sensors_missing.length > 0
      complete = false
      @begin_request(day, freq, sensors_missing)
      sensors_missing = []

    if !complete and freq < 60
      complete = true

    unless complete
      # Request the global_loading value so we become subscribers of it
      global_loading = gs.loading_mgr.loading()
      #unless global_loading
      #  gs.loading_mgr.loading true

    return [sensor_data, complete]

  get_raw_data: (start_date, end_date, freq, pks) ->
    # Returns an object containing data for each of the pks requested.
    #  That object is in the following format
    #    {
    #      1: [[day1 samples], [day2 samples] ...],
    #      2: [[day1 samples], [day2 samples] ...],
    #    }

    start_date = gs.to_utc(start_date)
    end_date = gs.to_utc(end_date)

    if freq >= 15 * 60
      day_list = make_day_list(start_date, end_date, 7)
    else
      day_list = make_day_list(start_date, end_date, 1)

    complete = true
    sensor_data = []
    sensor_data[i] = [] for i, pk of pks
    sensors_missing = []

    for own idx, day of day_list
      sensor_idx = -1
      for pk in pks
        sensor_idx += 1
        store = @get_store(day, pk, freq, sensors_missing)
        if store.loading
          complete = false
          sensor_data[sensor_idx].push([])
        else
          sensor_data[sensor_idx].push(store.data)

      if sensors_missing.length > 0
        complete = false
        @begin_request(day, freq, sensors_missing)
        sensors_missing = []

    return [sensor_data, complete]

  set_building: (building) ->
    @building = building

  notify_new_seconds: (data) ->
    # Data is an object mapping pks to new samples. Each set of new samples is either
    #  a single integer or a list of values representing the last few seconds.
    # Append these new seconds to the end of the current second data buffer.

    sensors_missing = []
    now_utc = gs.to_utc(new Date())
    day = new Date(now_utc).clearTime()
    now_millis = +now_utc

    for own pk, new_samples of data

      store = @get_store(day, pk, 1, sensors_missing)
#      if store.data.length == 0
#        # Store is new. Set the first time to match the current time. This avoids lots of Nones at the start
#        #  of the data.
#        store.start_time = store.start_time = now_utc

      unless new_samples.length?
        # Convert plain single readings into a list with one element.
        new_samples = [new_samples]

      if data.num_new?
        first_time = now_millis - (1000 * data.num_new)
      else
        first_time = now_millis - 1000

      extra_seconds = (first_time - store.end_time()) / 1000
      if extra_seconds > 0
        store.data = store.data.concat(new Array(extra_seconds))
        if extra_seconds < 10
          # Fill in holes.
          first_reading = store.data[store.data.length - extra_seconds - 1]
          last_reading = new_samples[0]

          for idx in [0 .. extra_seconds - 1]
            array_idx = store.data.length - extra_seconds + idx
            interp = ((0.5 + idx) / extra_seconds)
            interp_reading = (first_reading * (1-interp)) + (last_reading * interp)
            store.data[array_idx] = interp_reading

      store.data = store.data.concat(new_samples)
      store.loading = false

    @last_live_update new Date()

window.gs.SDM = SensorDataManager
window.gs.DataStore = DataStore
window.gs.DataCursor = DataCursor

window.gs.to_utc = to_utc
window.gs.to_local = to_local
window.gs.fix_holes = fix_holes
window.gs.missing_data_0 = missing_data_0

window.gs.calculate_statistics = calculate_statistics
window.gs.flatten_data = flatten_data
window.gs.find_nearest_value = find_nearest_value
